import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const massopsViewOnlyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.MassopsView],
}

// Access control for admin page - requires manage_users.legacy_permission
export const massopsAdminAccessControl: DomainAccessControlConfig = {
  permissions: ['manage_users.legacy_permission' as Permission],
}

export function getMassopsOperatePermission(interventionTypeId: string): Permission {
  return `massops.operate_${interventionTypeId}` as Permission
}

/**
 * Access control config that checks if a user has ANY operate permission.
 * Returns an array of configs - hasAccess() uses OR logic when given an array,
 * so it returns true if user has at least one of the permissions.
 */
export const allMassopsOperatePermissionsConfig: DomainAccessControlConfig = [
  { permissions: [Permission.MassopsOperateAppeaseUser] },
  { permissions: [Permission.MassopsOperateAppeaseUserVaryingPolicy] },
  { permissions: [Permission.MassopsOperateAppeaseUserByOrderDelivery] },
  { permissions: [Permission.MassopsOperateAppeaseUserVaryingAmountByOrderDelivery] },
  { permissions: [Permission.MassopsOperateAppeaseUserVaryingPolicyByOrderDelivery] },
  { permissions: [Permission.MassopsOperateCancelOrder] },
  { permissions: [Permission.MassopsOperateContactUser] },
  { permissions: [Permission.MassopsOperateGrantCreditBack] },
  { permissions: [Permission.MassopsOperateRefundChargeLog] },
  { permissions: [Permission.MassopsOperateRefundCustomerFee] },
  { permissions: [Permission.MassopsOperateRefundOrder] },
  { permissions: [Permission.MassopsOperateRescheduleDelivery] },
  { permissions: [Permission.MassopsOperateRevokeAppeasement] },
  { permissions: [Permission.MassopsOperateMigrateToppsWallet] },
  { permissions: [Permission.MassopsOperateSweepToppsWallet] },
]

/**
 * Access control config that checks if a user has:
 * - massops.view permission (mandatory)
 * - AND at least one massops.operate_* permission
 *
 * Uses array of configs with OR logic: (view AND operate_a) OR (view AND operate_b) OR ...
 * This is logically equivalent to: view AND (operate_a OR operate_b OR ...)
 */
export const massopsViewAndOperateAccessControl: DomainAccessControlConfig = [
  { permissions: [Permission.MassopsView, Permission.MassopsOperateAppeaseUser] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateAppeaseUserVaryingPolicy] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateAppeaseUserByOrderDelivery] },
  {
    permissions: [
      Permission.MassopsView,
      Permission.MassopsOperateAppeaseUserVaryingAmountByOrderDelivery,
    ],
  },
  {
    permissions: [
      Permission.MassopsView,
      Permission.MassopsOperateAppeaseUserVaryingPolicyByOrderDelivery,
    ],
  },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateCancelOrder] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateContactUser] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateGrantCreditBack] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateRefundChargeLog] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateRefundCustomerFee] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateRefundOrder] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateRescheduleDelivery] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateRevokeAppeasement] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateMigrateToppsWallet] },
  { permissions: [Permission.MassopsView, Permission.MassopsOperateSweepToppsWallet] },
]
